module.exports = __webpack_public_path__ + "img/banner.f085de11.jpg";